/* Guards against Swiper throwing when its target carousel isn't present on a
   given page, AND against Swiper never having loaded at all (which happens
   in some contexts, like the theme editor's preview iframe, where the vendor
   script can fail to load in time). Beauten's main.js initializes ~25
   different carousels unconditionally; if even one target element is missing
   OR the library itself isn't defined yet, the original code throws and
   halts the rest of that script — including code needed elsewhere on the
   page. This wraps (or fully stubs) Swiper so both cases are safe no-ops
   instead of hard errors. */
(function () {
  var RealSwiper = (typeof Swiper !== "undefined") ? Swiper : null;

  function stubInstance() {
    return {
      update: function () {},
      destroy: function () {},
      slideTo: function () {},
      slideNext: function () {},
      slidePrev: function () {},
      on: function () {},
      params: {},
      slides: [],
      el: null
    };
  }

  function SafeSwiper(selector, options) {
    var target = null;
    try {
      target = typeof selector === "string" ? document.querySelector(selector) : selector;
    } catch (e) {
      target = null;
    }

    if (!target || !RealSwiper) {
      // Missing target element, or the real Swiper library never loaded —
      // either way, return a harmless stub instead of throwing.
      return stubInstance();
    }

    return new RealSwiper(selector, options);
  }

  if (RealSwiper) {
    for (var key in RealSwiper) {
      if (Object.prototype.hasOwnProperty.call(RealSwiper, key)) {
        SafeSwiper[key] = RealSwiper[key];
      }
    }
    SafeSwiper.prototype = RealSwiper.prototype;
  }

  window.Swiper = SafeSwiper;
})();
